import React from 'react';

export function KeyboardArrowRightIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M17.18 33.18L26.34 24l-9.16-9.18L20 12l12 12-12 12-2.82-2.82z" />
    </svg>
  );
}
